// extracted by mini-css-extract-plugin
module.exports = {"narrow":"style-module_narrow__UPmoC6eRq4snAXd4v2vS"};